import React, { useEffect, useRef } from 'react';
import { Loader } from '@googlemaps/js-api-loader';
import './GoogleSunroofMap.scss';

const googleMapApi = process.env.REACT_APP_GOOGLE_MAP_API;

const GoogleSunroofMap = ({ lat, lng }) => {
  const mapRef = useRef(null);

  useEffect(() => {
    const loader = new Loader({
      apiKey: googleMapApi,
      version: 'weekly'
    });

    loader.load().then(() => {
      const initMap = async () => {
        const { Map } = await window.google.maps.importLibrary('maps');

        const map = new Map(mapRef.current, {
          center: { lat, lng },
          zoom: 19,
          mapTypeControl: false,
          streetViewControl: false
          //   fullscreenControl: false, // Hide the full-screen button
          //   zoomControl: false // Hide the zoom buttons
          //   draggable: false // Disable map movement
        });

        const layerID = 'sunroof';

        const layer = new window.google.maps.ImageMapType({
          name: layerID,
          getTileUrl: (coords, zoom) =>
            `https://storage.googleapis.com/solar_tiles_all_2018q2/tile_${coords.x}_${coords.y}_${zoom}.png`,
          tileSize: new window.google.maps.Size(256, 256),
          minZoom: 19,
          maxZoom: 20
        });

        map.mapTypes.set(layerID, layer);
        map.setMapTypeId(layerID);

        // eslint-disable-next-line no-new
        new window.google.maps.Marker({
          position: map.center,
          map
        });
      };

      initMap();
    });
  }, [lat, lng]);

  return (
    <div className="relative">
      <div ref={mapRef} style={{ width: '100%', height: '486px', borderRadius: '4px' }} />
      <div className="address-legend">
        <div className="legend-gradient" />
        <span className="legend-gradient-label left pt-caption">Shady</span>
        <span className="legend-gradient-label right pt-caption">Sunny</span>
      </div>
    </div>
  );
};

export default GoogleSunroofMap;
